<template>
    <div id="onglets-overview" :class="{active:open}" @click.exact="toggle">
        <draggable
            class="draggable"
            v-model="nav.contents"
            @change="change"
            handle=".card"
        >
        <card
            v-for="onglet in nav.contents"
            :key="onglet.router"
            :style="'border-bottom: 2px solid '+onglet.color"
            :item="onglet"
            :can-delete="false"
            :show-type="true"
            :active="onglet.active"
            @select="select(onglet)"
        />
        </draggable>
    </div>
</template>

<script>
import draggable     from 'vuedraggable'
import events from "@/events/events";
import Card from "@/modules/items/card";
import nav from "@/class/nav/nav";

export default {
    name: "Onglets_Overview",
    components: {Card,draggable},
    data(){
        return {
            open: false,
            nav:nav,
        }
    },
    methods:{
        toggle(){
            this.open = !this.open;
            console.log(this.open)
        },
        select(onglet){
            onglets.active(onglet)
        },
        close(){
            this.open = false;
        },
        change(val){
        
            // storedOnglets.splice(val.moved.oldIndex,1)
            // storedOnglets.splice(val.moved.newIndex,0,val.moved.element)
            //
            // this.ongletsAll =  storedOnglets;
            // onglets.save()
        },
    },
    mounted() {
        
        events.$on("body:keydown:switch-tab",this.toggle)
        events.$on("body:keydown:escape",this.close)
    },
    destroyed() {
        events.$off("body:keydown:switch-tab",this.toggle)
        events.$off("body:keydown:escape",this.close)
    }
}
</script>